import React, { useContext, useEffect } from 'react';
import { Link, useHistory, Redirect } from 'react-router-dom';
import avatar from '../images/user2.png';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { 
  AppBar,
  Box, 
  Button,
  CssBaseline,
  Divider,
  Drawer,
  Fab,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useScrollTrigger,
  Zoom
} from '@material-ui/core';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import GamepadIcon from '@material-ui/icons/Gamepad';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { UserContext } from './userContext';
import Content from './content';
import { Autorenew } from '@material-ui/icons';

// NAVBAR AND SIDEBAR STYLES
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    // overflowX: 'hidden',
    minWidth: 318,
    display: 'flex',
    // position: 'fixed',
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(30,30,30,1)'
    },
    padding: 0,
    // '& .MuiPaper-elevation4': {
    //   boxShadow: 'none'
    // }
  },
  iconButtonPadding: {
    marginRight: theme.spacing(1),
    '@media (max-width:599px)': {
      padding: '4px',
      marginLeft: '-4px',
      marginRight: theme.spacing(2),
    },
    '@media (min-width:600px)': {
      padding: '8px',
      marginLeft: '-8px'
    }
  },
  stickyAppBar: {
    position: 'sticky',
    top: '56px',
    right: 0,
    left: 0,
    '@media (max-width:599px)': {
      top: '48px'
    }
  },
  appBar: {
    // minWidth: 318,
    marginLeft: -drawerWidth,
    width: '100%',
    maxHeight: '40px',
    minHeight: '48px',
    transition: 'all 0.225s ease-out',
    zIndex: 1099,
    '@media (max-width:599px)': {
      // marginLeft: '-100%',
      marginLeft: 0,
      minHeight: '40px',
    },
  },
  appBarShift: {
    marginLeft: 0,
    width: `calc(100% - ${drawerWidth}px)`,
    // transition: 'all 0.25s ease',
    '@media (max-width:599px)': {
      zIndex: 1097,
      marginLeft: '-100%',
      // marginLeft: '100%',
      display: 'none'
    },
  },
  toolbar: {
    padding: theme.spacing(0, 5),
    '@media (max-width:599px)': {
      minHeight: '40px',
      padding: theme.spacing(0, 3)
    },
    '@media (min-width:600px)': {
      minHeight: '48px'
    }
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(26, 26, 26, 0.975)',
    },
    '& .MuiDrawer-paperAnchorDockedLeft': {
      borderRight: 'none',
    },
    '@media (max-width:599px)': {
      width: '0%'
    },
    '& hr': {
      backgroundColor: 'rgba(81, 81, 81, 1)',
    }
  },
  drawerOpen: {
    '@media (max-width:599px)': {
      // minWidth: 318,
      width: '100%',
    },
  },
  drawerPaper: {
    position: 'static',
    marginLeft: 0,
  },
  drawerRoot: {
    position: 'sticky',
    top: '56px',
    left: 0,
    right: 'auto',
    height: `calc(100vh - 56px)`,
    zIndex: 1098, 
    '@media (max-width:599px)': {
      top: '48px',
      height: `calc(100vh - 48px)`,
      // zIndex: 1099
    },
    '@media (min-width:600px)': {
      top: '56px'
    },
  },
  drawerRootOpen: {
    zIndex: 1100,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 0),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    maxHeight: '40px',
    '@media (max-width:599px)': {
      minHeight: '40px'
    },
    '@media (min-width:600px)': {
      minHeight: '48px'
    }
  },
  user: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 120,
    height: 120,
    borderRadius: 60,
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(1, 1),
    marginBottom: '8px',
    color: theme.palette.text.secondary,
    // boxShadow: theme.shadows[4]
  },
  drawerItemList: {
    position: 'relative',
    left: 24,
    top: 0,
    boxSizing: 'border-box',
    height: 48,
    width: `calc(100% - 24px)`,
    textDecoration: 'none',
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 2),
    transition: 'padding 0.5s ease, color 0.5s ease',
    marginBottom: 16,
    cursor: 'pointer',
    '@media (max-width:599px)': {
      left: 16,
      width: `calc(100% - 16px)`,
      padding: theme.spacing(1),
    },
    '& .MuiListItemIcon-root': {
      minWidth: '35px',
      color: theme.palette.text.secondary,
    },
    '& b:nth-child(1) ': {
      boxSizing: 'border-box',
      position: 'absolute',
      top: '-24px',
      right: 0,
      height: 24,
      width: 24,
      backgroundColor: 'rgb(30, 30, 30)',
      display: 'none'
    },
    '& b:nth-child(2)': {
      boxSizing: 'border-box',
      position: 'absolute',
      bottom: '-24px',
      right: 0,
      height: 24,
      width: 24,
      backgroundColor: 'rgb(30, 30, 30)',
      display: 'none'
    },
    '&:hover': {
      paddingLeft: 32,
      color: 'rgb(163, 102, 255)',
      '& .MuiListItemIcon-root': {
        color: 'rgb(163, 102, 255)',
      },
    //   '& b:nth-child(1)': {
    //   // '&:before': {
    //   //   left: '-16px'
    //   // },
    //   display: 'block',
    // },
    // '& b:nth-child(2)': {
    //   // '&:before': {
    //   //   left: '-16px'
    //   // },
    //   display: 'block',
    // },
    }
  },
  activeDrawerItemList: {
    '& b:nth-child(1)': {
      display: 'block',
      '&:before': {
        // borderRight: '1px solid rgb(163, 102, 255)',
        borderBottom: '1px solid rgb(163, 102, 255)',
      },
    },
    '& b:nth-child(2)': {
      display: 'block',
      '&:before': {
        // borderRight: '1px solid rgb(163, 102, 255)',
        borderTop: '1px solid rgb(163, 102, 255)',
      },
    },
    backgroundColor: 'rgb(30, 30, 30)',
    borderTopLeftRadius: 24,
    borderBottomLeftRadius: 24,
    borderTop: '1px solid rgb(163, 102, 255)',
    borderLeft: '1px solid rgb(163, 102, 255)',
    borderBottom: '1px solid rgb(163, 102, 255)',
    paddingLeft: 32,
    transition: 'padding 0.5s ease, color 0.5s ease',
    color: 'rgb(163, 102, 255)',
    '& .MuiListItemIcon-root': {
      color: 'rgb(163, 102, 255)',
    },
  },
  contentRoot: {
    width: '100%',
    // overflowX: 'hidden',
    marginLeft: 0,
    // flexGrow: 1,
    transition: 'all 0.225s ease-out',
    padding: theme.spacing(0, 5),
    '@media (max-width:599px)': {
      padding: theme.spacing(0, 3)
    }
  },
  content: {
    // flexGrow: 1,
    marginLeft: '-100%',
    padding: theme.spacing(0, 5),
    zIndex: 1098,
    '@media (max-width:599px)': {
      padding: theme.spacing(0, 3),
      marginLeft: '-100%',
    }
  },
  contentShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `calc(-100% + ${drawerWidth}px)`,
    '@media (max-width:599px)': {
      width: '100%',
      zIndex: 1097,
      marginLeft: '-100%',
      // marginLeft: 0,
      padding: theme.spacing(0, 3),
      display: 'none'
    },
  },
  scrollTop: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  anchorHeader: {
    display: 'flex',
    maxHeight: '40px',
    '@media (max-width:599px)': {
      minHeight: '40px'
    },
    '@media (min-width:600px)': {
      minHeight: '48px'
    }
  },
  scrollAnchor: {
    height: 0,
    marginBottom: '40px',
    '@media (max-width:599px)': {
      marginBottom: '24px'
    },
  },
  link: {
    color: theme.palette.text.secondary,
    textDecoration: 'none'
  }
}));

// SCROLL TOP
function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    console.log(event);
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.scrollTop}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

function Copyright(props) {
  const { setPathName } = props;
  const classes = useStyles();
  return (
    <Box mt={2} mb={2}>
      <Typography variant="body2" align="center" color="textSecondary">
        {'Copyright © '}
        <Link to='/' name='/' onClick={(event) => setPathName(event.currentTarget.name)} className={classes.link}>Clairvoyant</Link>{' '}{new Date().getFullYear()}
      </Typography>
    </Box>
  );
}

// MAIN COMPONENT
export default function Dashboard(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { user, setUser, pathName, setPathName, open, setOpen } = useContext(UserContext);
  // const [ open, setOpen ] = React.useState(false);
  let history = useHistory();
  
  // useEffect(() => {
  //   setPathName(window.location.pathname);  
  //   console.log(window.location.pathname)
  // }, [pathName])
  
  console.log(pathName)
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = (event) => {
    setOpen(false);
  };

  const handlePath = (event) => {
    if (window.innerWidth < 600) setOpen(false);
    setPathName(event.currentTarget.name)
  }

  const handleSignOut = () => {
    localStorage.removeItem('user');
    setUser(null);
    setOpen(false);
    alert(`You are signed out`);
    // setOpen(false);
    // return <Redirect to='/' />
    history.push(`/`);
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      {
        user ?
          (<>
            <Drawer
              className={clsx(classes.drawer, open && classes.drawerOpen)}
              variant="persistent"
              anchor="left"
              open={open}
              classes={{
                paper: classes.drawerPaper,
                root: clsx(classes.drawerRoot, open && classes.drawerRootOpen)
              }}
            >
              <div className={classes.drawerHeader}>
                <IconButton 
                  onClick={handleDrawerClose}
                  classes={{ root: classes.iconButtonPadding }}
                >
                  {theme.direction === 'ltr' ? <ChevronLeftRoundedIcon /> : <ChevronRightRoundedIcon />}
                </IconButton>
              </div>
              <div className={classes.user}>
                <img 
                  src={avatar} 
                  width={200} 
                  height={200} 
                  alt="user" 
                  style={{maxHeight: '50px', width: 'auto', margin: '10px 0', opacity: 0.7}} 
                />
                <Typography variant="h6" style={{textTransform: 'capitalize', lineHeight: '18px', color: '#fff', fontSize: '20px'}}>{user.name}</Typography>
                <Typography variant="subtitle" style={{fontSize: '11px'}}>{user.email}</Typography>
                
              </div>
              {/* <Divider /> */}
              <List className={classes.list}>
                <ListItem 
                  // button 
                  component={Link} 
                  to={`/${user.email}/dashboard/change-password`} 
                  name={`/${user.email}/dashboard/change-password`} 
                  onClick={handlePath}
                  className={clsx(classes.drawerItemList, pathName.match(`/${user.email}/dashboard/change-password`) ? classes.activeDrawerItemList : null)}
                >
                  <b></b>
                  <b></b>
                  <ListItemIcon><VpnKeyIcon /></ListItemIcon>
                  <ListItemText primary="Change Password" />
                </ListItem>
                <ListItem 
                  // button 
                  // key={text} 
                  component={Link} 
                  to={`/${user.email}/dashboard/movie-editor/list`} 
                  name={`/${user.email}/dashboard/movie-editor/list`} 
                  onClick={handlePath} 
                  className={clsx(classes.drawerItemList, 
                    pathName.match(`/${user.email}/dashboard/movie-editor/list`) 
                    || pathName.match(`/${user.email}/dashboard/movie-editor/edit`) 
                    || pathName.match(`/${user.email}/dashboard/movie-editor/create`) 
                    ? classes.activeDrawerItemList : null
                  )}
                >
                  <b></b>
                  <b></b>
                  <ListItemIcon>{<MovieCreationIcon />}</ListItemIcon>
                  <ListItemText primary="Movie Editor" />
                </ListItem>
                <ListItem 
                  // button 
                  // key={text} 
                  component={Link} 
                  to={`/${user.email}/dashboard/game-editor/list`} 
                  name={`/${user.email}/dashboard/game-editor/list`} 
                  onClick={handlePath} 
                  className={clsx(classes.drawerItemList, 
                    pathName.match(`/${user.email}/dashboard/game-editor/list`) 
                    || pathName.match(`/${user.email}/dashboard/game-editor/edit`) 
                    || pathName.match(`/${user.email}/dashboard/game-editor/create`) 
                    ? classes.activeDrawerItemList : null
                  )}
                >
                  <b></b>
                  <b></b>
                  <ListItemIcon>{<GamepadIcon />}</ListItemIcon>
                  <ListItemText primary="Game Editor" />
                </ListItem>
                <ListItem 
                  // button 
                  // key='Sign Out' 
                  onClick={handleSignOut} 
                  className={classes.drawerItemList}
                >
                  <b></b>
                  <b></b>
                  <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                  <ListItemText primary='Sign Out' />
                </ListItem>
              </List>
              {/* <Divider /> */}
              {/* <List>
                {['All mail', 'Trash', 'Spam'].map((text, index) => (
                  <ListItem button key={text}>
                    <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItem>
                ))}
              </List> */}
            </Drawer>
            
            <AppBar
              color="inherit"
              position="sticky"
              className={clsx(classes.appBar, {
                [classes.appBarShift]: open,
              })}
              classes={{ 
                positionSticky: classes.stickyAppBar,
                // root: classes.appBarRoot
              }}
              style={{backgroundColor: 'rgba(26,26,26,0.975)'}}
            >
              <Toolbar classes={{ regular: classes.toolbar }}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  className={clsx(classes.menuButton, open && classes.hide)}
                  classes={{ root: classes.iconButtonPadding }}
                >
                  <DashboardRoundedIcon />
                </IconButton>
                <Typography variant="h6" noWrap>
                  Dashboard
                </Typography>
              </Toolbar>
            </AppBar>
          </>)
        :
          <></>
      }      
      <main
        className={clsx(classes.contentRoot, open && classes.contentShift, user && classes.content)}
      >
        <div id="back-to-top-anchor" className={clsx(classes.scrollAnchor, user && classes.anchorHeader)} />
        <Content />
        <Copyright setPathName={setPathName} />
        <ScrollTop {...props}>
        <Fab classes={{ secondary: classes.fabColor }} color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpRoundedIcon />
        </Fab>
      </ScrollTop>
      </main>
    </div>
  );
}